// src/helper/yapas.js
import db from '../../db';

// "30"  => ["30","0","0"]
// "30+10" => ["30","10","0"]
// "30+10+5" => ["30","10","5"]
function normalizeIskonto(rawIskonto) {
    var isk = (rawIskonto || '0').toString().trim();

    if (isk === '') {
        isk = '0';
    }

    var parts = isk.split('+');

    if (parts.length === 1) {
        return [parts[0], '0', '0'];
    }
    if (parts.length === 2) {
        return [parts[0], parts[1], '0'];
    }
    return [parts[0], parts[1], parts[2]];
}

// extra: { fiyat, kdv }
// helper: this.$helper
// aktifCari: seçili cari (componentten göndereceğiz)
// kdvli: 1 veya 0 (fiyat kdv'li mi geliyor)
async function getFiyat(extra, helper, kdvli, iskontokod, kampanya, doviz) {


    //const aktifCari = await db.caris.toCollection().filter(function (c) { return c.secili === true; }).first();

    var oranlar = normalizeIskonto(iskontokod);

    var fiyati = extra.fiyat * helper.doviz[doviz];

    if (kampanya > 0) {
        fiyati = kampanya;
    }
    var kdvSonuc = helper.kdvharicgoster(fiyati, kdvli, extra.kdv);

    var fiyat = {
        liste: kdvSonuc.kdvsiz,   // KDV hariç liste
        iskontolu: kdvSonuc.kdvsiz,
        iskonto: []
    };

    var current = fiyat.liste;

    oranlar.forEach(function (oranStr) {
        var oran = parseFloat(oranStr);
        if (isNaN(oran)) {
            oran = 0;
        }
        var onceki = current;
        current = helper.iskontohesap(onceki, oran);

        fiyat.iskonto.push({
            oran: oran,
            tutar: current,
            fark: onceki - current
        });
    });

    fiyat.iskontolu = current;

    return fiyat;
}

export default {
    getFiyat: getFiyat
};



// WEBPACK FOOTER //
// ./src/services/fiyat/yapas.js